import React, { useState, useEffect, useContext } from "react";
import Result from "./CardTeaser";
import { GlobalContext } from "./../Context";
import getPostalAbbreviation from "./../Global/getPostalAbbreviation";
import removeQueryParams from "./../Global/removeQueryParams";
import "./CardTeaser.scss";
import { ServiceType } from "../ServiceType";

function ResultsView({ data }) {
  const [cardListState, setCardListState] = useState("close");
  const [sortedBranches, setSortedBranches] = useState([]);
  const [initialTouchClientY, setInitialTouchClientY] = useState(0);

  const globalContext = useContext(GlobalContext);

  const {
    setCurrentPopUp,
    branches,
    setBranches,
    initialPos,
    mapsInstance,
    setMarkersVisibility,
    setResultsState,
    setFiltersVisibility,
    langcode,
    setFilterCardState,
    setBackButtonVisibility,
  } = globalContext;

  // ✅ SOLO efecto de UI (SEGURO con JScrambler)
  useEffect(() => {
    const isOpen = cardListState === "open";
    const map = document.querySelector(".map");

    document.body.style.overflow = isOpen ? "hidden" : "";

    if (map) {
      map.style.pointerEvents = isOpen ? "none" : "";
    }

    return () => {
      document.body.style.overflow = "";
      if (map) map.style.pointerEvents = "";
    };
  }, [cardListState]);

  useEffect(() => {
    if (mapsInstance) {
      let distanceSortCallBack = (a, b) => {
        let { google } = mapsInstance;

        let queryCircle = new google.maps.Circle({
          center: new google.maps.LatLng(initialPos),
        });

        let locationA = new google.maps.LatLng({
          lat: a.fieldCoordinates.lat,
          lng: a.fieldCoordinates.lng,
        });

        let locationB = new google.maps.LatLng({
          lat: b.fieldCoordinates.lat,
          lng: b.fieldCoordinates.lng,
        });

        let markerA = new google.maps.Marker({
          position: locationA,
        });

        let markerB = new google.maps.Marker({
          position: locationB,
        });

        let distanceA = google.maps.geometry.spherical.computeDistanceBetween(
          markerA.getPosition(),
          queryCircle.getCenter()
        );

        let distanceB = google.maps.geometry.spherical.computeDistanceBetween(
          markerB.getPosition(),
          queryCircle.getCenter()
        );

        return distanceA - distanceB;
      };

      let featuredBranches = branches
        .filter((branch) => branch.fieldFeatured)
        .sort(distanceSortCallBack);

      let commonBranches = branches
        .filter((branch) => !branch.fieldFeatured)
        .sort(distanceSortCallBack);

      let sortedArray = featuredBranches.concat(commonBranches);
      setSortedBranches(sortedArray);
    }
  }, [branches, mapsInstance, initialPos]);

  return (
    <div className="card-teaser-list__container">
      <div
        onTouchMove={(event) => {
          const touchY = event.touches[0].clientY;

          if (touchY < initialTouchClientY) {
            setCardListState("open");

            // ✅ SAFE
            if (typeof setBackButtonVisibility === "function") {
              setBackButtonVisibility(false);
            }
          }
        }}
        onTouchStart={(event) => {
          setInitialTouchClientY(event.touches[0].clientY);
        }}
        className={`card-teaser-list__content ${cardListState === "open"
            ? "card-teaser-list__content--open"
            : ""
          }`}
      >
        <ServiceType data={data} isResultView={true} />

        <div className="card-teaser-action-container">
          <button
            className={`card-teaser-list__content__return__button ${cardListState === "close"
                ? "card-teaser-list__content__return__button--open"
                : ""
              }`}
            onClick={() => {
              setResultsState(false);
              setBranches([]);
              setFiltersVisibility(true);
              setMarkersVisibility(false);
              setCurrentPopUp(false);
              removeQueryParams();
              setFilterCardState("close");

              // ✅ SAFE
              if (typeof setBackButtonVisibility === "function") {
                setBackButtonVisibility(true);
              }
            }}
          >
            Volver a la búsqueda
          </button>

          <button
            className={`card-teaser-list__content__button ${cardListState === "close"
                ? "card-teaser-list__content__button--open"
                : ""
              }`}
            onClick={() => {
              setCardListState((prev) => {
                const next = prev === "close" ? "open" : "close";

                // ✅ FIX PRINCIPAL (JScrambler-safe)
                if (typeof setBackButtonVisibility === "function") {
                  setBackButtonVisibility(next !== "open");
                }

                return next;
              });
            }}
            onTouchMove={(event) => {
              const touchY = event.touches[0].clientY;

              if (touchY > initialTouchClientY) {
                setCardListState("close");

                // ✅ SAFE
                if (typeof setBackButtonVisibility === "function") {
                  setBackButtonVisibility(true);
                }
              }
            }}
            onTouchStart={(event) => {
              setInitialTouchClientY(event.touches[0].clientY);
            }}
          >

            {cardListState === "close" && (
              <img
                className="card-image"
                src="/modules/custom/bac_locations/js/src/assets/img/list-items.svg"
                alt="List item"
              />
            )}

            {cardListState === "close"
              ? "Ver resultados"
              : "Ver mapa"}

            {cardListState !== "close" && (
              <img
                className="card-image"
                src="/modules/custom/bac_locations/js/src/assets/img/location-point.svg"
                alt="location"
              />
            )}

          </button>
        </div>

        <div className="card-teaser-list__cards">
          {sortedBranches.length !== 0 &&
            sortedBranches.map((data, index) => {
              return (
                <Result
                  id={`${data.entityLabel
                    .toLowerCase()
                    .replace(/ /g, "")}-${index}`}
                  key={data.entityId || index}
                  name={data.entityLabel}
                  entityId={data.entityId}
                  type={data.fieldOfficeBranchType}
                  isFeatured={data.fieldFeatured}
                  location={data.fieldAddress}
                  date={data.fieldSchedule}
                  dateCounter={data.fieldScheduleCounter}
                  services={data.queryFieldServices || []}
                  coordinates={data.fieldCoordinates}
                  image={data.fieldOfficeBranchImage}
                  deactivateSchedule={data.fieldDesactivarHorario}
                  hasElectricCharger={data.fieldElectricCharger}
                  deactivatePhone={data.fieldDesactivarTelefono}
                  aditionalInfo={data.fieldDisclamer}
                  mobilePhone={data.fieldMobilePhone}
                  principalPhone={data.fieldPrincipalPhone}
                  geographyLocation={
                    data[
                    `fieldGeographyLocation${getPostalAbbreviation(
                      langcode
                    )}`
                    ]
                  }
                  setCardListState={setCardListState}
                  fieldLocation={data.fieldLocation}
                  fieldEnableBranchAppointments={
                    data.fieldEnableBranchAppointments
                  }
                />
              );
            })}

          {sortedBranches.length === 0 && (
            <div className="card-teaser-list-error">
              <p className="place-search__submit-help-text place-search__submit-help-text--error">
                No se han podido encontrar resultados, por favor modifique su
                búsqueda o ingrese una ubicación diferente.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResultsView;
